import {FC} from 'react'

const NoPermission: FC = () => {
  return (
    <>
      <h1 className='fw-bolder fs-4x text-gray-700 mb-10'>
        You don't have permission for this page.
      </h1>

      <div className='fw-bold fs-3 text-gray-400 mb-15'>Please ask to support team.</div>
    </>
  )
}

export default NoPermission
